import { api } from '@api'
import type { Database, Json } from '@hvf/contracts'
import type { SearchCategory } from './categories'

type Row = Database['public']['Functions']['global_search']['Returns'][number]

export type SearchResult = Omit<Row, 'category' | 'meta'> & {
  category: SearchCategory
  meta: Record<string, string | number | boolean | null>
}

export const MIN_QUERY_LENGTH = 2

export const globalSearch = async (
  query: string,
  category?: SearchCategory,
  filters?: Record<string, unknown>,
): Promise<SearchResult[]> => {
  const { data, error } = await api().rpc('global_search', {
    p_query: query,
    p_category: category,
    // A single category gets a deeper list; "All" shows the top few of each
    p_limit: category ? 30 : 4,
    p_filters: (filters ?? {}) as Json,
  })
  if (error) throw error
  return (data ?? []) as SearchResult[]
}
